import BaseClass from "./BaseClass";

const defaultOptions = {};

export default class Url extends BaseClass {

  /**
   * Constructor
   * @param options
   */
    constructor(options)
    {
        super(options, defaultOptions);

        this.sessionToUrl = {};
        this.activeParams = {};

        this.init();
    }

    init()
    {
        var classinstance = this;
        this.activeParams = JSON.parse($('meta[name="latest-url-params-json"]').attr('content'));
        if (Array.isArray(this.activeParams)) {
            this.activeParams = {};
        }
        this.replaceUrlParams();

        $.ajax({
            method: 'POST',
            url: window.location.origin + "/api/url/get-trans-array",
            data: {
                '_token': $('meta[name="csrf-token"]').attr('content')
            },
            dataType: 'json',
            success: function (data) {
                classinstance.sessionToUrl = data;
            }
        });
    }

  /**
   * This function will add given parameters to url.
   *
   * @param {Object} paramsValues parameters to store
   * @param {String} parent if those are sub parameters
   */
    addOrReplaceActiveParam(paramsValues, parent = undefined)
    {
        var classinstance = this;

        if (Object.keys(classinstance.sessionToUrl).length > 0) {
            var translatedParent = '';
            if (parent != undefined) {
                translatedParent = classinstance.sessionToUrl[parent].name;
            }

            var emptyParams = [];
            Object.keys(paramsValues).forEach(function (param) {
                if (!Array.isArray(paramsValues[param]) || (Array.isArray(paramsValues[param]) && paramsValues[param].length > 0)) {
                  // If the params are also in array (for instance rooms setting)
                    if (Array.isArray(paramsValues[param]) && parent == undefined) {
                        var paramsArr = paramsValues[param];
                        // Parent is currently loopedparameter
                        var parentTmp = param;
                        translatedParent = classinstance.sessionToUrl[param].name;

                        var urlArr = [];
                        // Build same array of parameters but with translated subParameters
                        for (var i = 0; i < paramsArr.length; i++) {
                            var urlParams = {};
                            Object.keys(paramsArr[i]).forEach(function (subParam) {
                                subParam = subParam.split('_');
                                let translatedParam = classinstance.sessionToUrl[parentTmp].subParams[subParam[0]];
                                if (typeof subParam[1] != 'undefined') {
                                    translatedParam += '_' + subParam[1];
                                }

                                if (paramsArr[i][subParam.join('_')] != undefined) {
                                    urlParams[translatedParam] = paramsArr[i][subParam.join('_')];
                                }
                            });

                            urlArr.push(urlParams);
                        }

                        classinstance.activeParams[translatedParent] = urlArr;
                    } else {
                        param = param.split('_');

                        let translatedParam;
                      // If parent is set, then store translated params under translated parent
                        if (parent != undefined) {
                            translatedParam = classinstance.sessionToUrl[parent].subParams[param[0]];
                            if (typeof param[1] != 'undefined') {
                                translatedParam += '_' + param[1];
                            };

                            if (paramsValues[param.join('_')] != undefined) {
                                if (classinstance.activeParams[translatedParent] === undefined) {
                                    classinstance.activeParams[translatedParent] = {};
                                }
                                classinstance.activeParams[translatedParent][translatedParam] = paramsValues[param.join('_')];
                            }
                        } else {
                            translatedParam = classinstance.sessionToUrl[param[0]].name;
                            if (typeof param[1] != 'undefined') {
                                translatedParam += '_' + param[1];
                            }

                            if (paramsValues[param.join('_')] != undefined) {
                                if (classinstance.activeParams[translatedParam] === undefined) {
                                    classinstance.activeParams[translatedParam] = {};
                                }

                                classinstance.activeParams[translatedParam] = paramsValues[param.join('_')];
                            }
                        }
                    }
                } else if (Array.isArray(paramsValues[param]) && paramsValues[param].length == 0) {
                    emptyParams.push(param);
                }
            });

            if (emptyParams.length > 0) {
                this.deleteActiveParams(emptyParams, parent);
            }
        }

        this.replaceUrlParams();
    }

  /**
   * This function deletes given parameters and refresh url
   *
   * @param {Array} paramsNames names of parameters to delete
   * @param {String} parent if those are sub parameters
   */
    deleteActiveParams(paramsNames, parent = undefined)
    {
        var translatedParent = '';
        if (parent !== undefined && this.sessionToUrl[parent] !== undefined) {
            translatedParent = this.sessionToUrl[parent].name;
        }

        for (var i = 0; i < paramsNames.length; i++) {
            let paramNameArr = paramsNames[i].split('_');

            var translatedParam = '';

            if (parent !== undefined) {
                translatedParam = this.sessionToUrl[parent].subParams[paramNameArr[0]];
                if (typeof paramNameArr[1] != 'undefined') {
                    translatedParam += '_' + paramNameArr[1];
                }

                delete this.activeParams[translatedParent][translatedParam];
            } else {
                translatedParam = this.sessionToUrl[paramNameArr[0]].name;
                if (typeof paramNameArr[1] != 'undefined') {
                    translatedParam += '_' + paramNameArr[1];
                }

                delete this.activeParams[translatedParam];
            }
        }

        this.replaceUrlParams();
    }

  /**
   * Will replace url params with active params in this class
   */
    replaceUrlParams()
    {
        let url = location.protocol + '//' + location.host + location.pathname;
        let parameters = this.encodeObjectToQuery(this.activeParams);
        let urlArray = window.location.toString().split('#')
        let uniqUrlArray = [...new Set(urlArray)];

        if (uniqUrlArray.length > 1) {
            window.history.replaceState({}, '', url + '?' + parameters + '#' + uniqUrlArray.at(-1));
        } else {
            window.history.replaceState({}, '', url + '?' + parameters);
        }
    }

  /**
   * Encode object recursively to url params string
   *
   * @param {Object} obj object that should be encoded
   * @param {String} prefix
   *
   * @returns {String} encoded object
   */
   encodeObjectToQuery(obj, prefix)
    {
        var str = [], p;
        for (p in obj) {
            if (obj.hasOwnProperty(p)) {
                var k = prefix ? prefix + "[" + p + "]" : p,
                v = obj[p];
                str.push((v !== null && typeof v === "object") ?
                this.encodeObjectToQuery(v, k) :
                encodeURIComponent(k) + "=" + encodeURIComponent(v));
            }
        }
        return str.join("&");
    }
}
